import ButtonDemo from './ButtonDemo'

export default ButtonDemo
// eslint-disable-next-line import/export
export * from './ButtonDemo'
